module.exports = __webpack_public_path__ + "static/media/Stellar Vox King Headboard - 180 cm.3299163f.jpg";